import React from "react";
import { Ratio } from "react-bootstrap";

const RenderMedia = ({ embed, aspectRatio }) => {
    const isExternalUrl = /^https?:\/\//i.test(embed);
    const isImageAsset = /\.(svg|png|jpe?g|gif|webp)(\?.*)?$/i.test(embed);

    if (isImageAsset && !isExternalUrl) {
        return (
            <Ratio aspectRatio={aspectRatio}>
                <img
                    src={embed}
                    alt=""
                    loading="lazy"
                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
            </Ratio>
        );
    }

    return (
        <Ratio aspectRatio={aspectRatio}>
            <iframe
                src={embed}
                title="Contenido multimedia"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
                style={{ border: 0 }}
            />
        </Ratio>
    );
};

export const SideToSide = ({ embed, dataHome = {}, leftToRight = true, Mark = true }) => {

    return (
        <section className="col mainClass__body">
            {leftToRight ?
                <>
                    {
                        Mark ?
                            <>
                                <div className="body__embed rounded" style={{ height: "auto" }}>
                                    <RenderMedia embed={embed} aspectRatio="16x9" />
                                </div>
                            </>
                            :
                            <RenderMedia embed={embed} aspectRatio="16x9" />
                    }
                    <div className="body__title">
                        <h2 className="titleFont">{dataHome.title}</h2>
                        <p>{dataHome.value}</p>
                    </div>
                </>
                :
                <>
                    <div className="body__title">
                        <h2 className="titleFont">{dataHome.title}</h2>
                        <p>{dataHome.value}</p>
                    </div>
                    {
                        Mark ?
                            <>
                                <div className="body__embed" style={{ height: "auto" }}>
                                    <RenderMedia embed={embed} aspectRatio="16x9" />
                                </div>
                            </>
                            :
                            <>
                                <div style={{ height: "auto", width: "25em" }}>
                                    <RenderMedia embed={embed} aspectRatio="1x1" />
                                </div>

                            </>
                    }
                </>
            }
        </section>
    );
};
